/** Shared Input/Select chrome for inventory add/edit forms. */
export const INVENTORY_FIELD_FOCUS_COLOR = 'brand.500';

export const inventoryFieldProps = {
    borderRadius: 'lg',
    focusBorderColor: INVENTORY_FIELD_FOCUS_COLOR,
} as const;
